export const replaceNewLine = (str: string) => (str?.length > 0 ? str.replace(/\\n+/g, '\n') : '');
